export default __webpack_public_path__ + "static/media/ping.199c5c86.png";